import { Card } from "../../components/ui/Card";
import { useFeatureFlags, useSetFeatureFlag } from "../../features/superadmin/api";

export default function SuperadminFeatureFlagsPage() {
  const { data, isLoading } = useFeatureFlags();
  const setFlag = useSetFeatureFlag();
  return (
    <Card title="Feature flags" subtitle="Runtime kill switches. Transactional Whatmail (invites, resets) bypasses these.">
      {isLoading ? <div className="skeleton-rows">Loading…</div> : (
        <div className="table-wrap">
          <table className="data-table">
            <thead>
              <tr><th>Key</th><th>Description</th><th>State</th></tr>
            </thead>
            <tbody>
              {(data?.flags ?? []).map((f) => (
                <tr key={f.key}>
                  <td><code>{f.key}</code></td>
                  <td>{f.description ?? "—"}</td>
                  <td>
                    <label className="toggle">
                      <input
                        type="checkbox"
                        checked={f.value}
                        onChange={(e) => setFlag.mutate({ key: f.key, value: e.target.checked })}
                      />
                      <span>{f.value ? "enabled" : "disabled"}</span>
                    </label>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}
